<template>
  <div class="flex items-center space-x-2 w-full border-b border-l-0 border-t-0 border-r-0 border-solid border-gray-200 mb-2 pb-2">
    <div>
      <label class="font-bold text-gray-900 mb-0">
        <span class="mb-2">{{ $t("title.lbl_during_of_time") }}</span>
        <span class="hodo-el block el-input--suffix">
          <input name="from_date" v-model="form.from_date" type="date" class="el-input__inner w-40 pr-3 bg-white border border-gray-200" :placeholder="$t('Chọn ngày')" :max="maxDateValue" @change="handleFilters" />
        </span>
      </label>
    </div>
    <div>
      <label class="font-bold text-gray-900 mb-0">
        <span class="mb-2">&nbsp;</span>
        <span class="hodo-el block el-input--suffix">
          <input name="to_date" v-model="form.to_date" type="date" class="el-input__inner w-40 pr-3 bg-white border border-gray-200" :placeholder="$t('Chọn ngày')" :max="maxDateValue" @change="handleFilters" />
        </span>
      </label>
    </div>
    <div>
      <label class="font-bold text-gray-900 mb-0 w-full">
        <span class="mb-2">{{ $t("lbl_patient_code") }}</span>
        <span class="hodo-el block">
          <el-input name="searchBox" :placeholder="$t('')" v-model="form.keyword" clearable @input="debounceSearch" />
        </span>
      </label>
    </div>
    <div>
      <label class="font-bold text-gray-900 mb-0">
        <span class="mb-2">{{ $t("state.state") }}</span>
        <span class="hodo-el block">
          <el-select name="status" v-model="form.status.value" :default-first-option="true" :placeholder="$t('Chọn trạng thái')" @change="handleFilters">
            <el-option v-for="item in form.status.options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </span>
      </label>
    </div>
  </div>
</template>

<style lang="css" scoped>
.hodo-el /deep/ .el-input__inner {
  background: white !important;
  border: 1px solid #dee2e6 !important;
}
.hodo-el /deep/ .el-input__inner.w-40 {
  min-width: 160px;
  width: auto;
}
</style>

<script>
export default {
  name: 'FiltersHeader',
  props: {
    isMaxDateToday: Boolean,
    isDateRange: {
      type: Boolean,
      default: true
    },
    customStatusData: Object
  },
  data () {
    return {
      today: this.moment(),
      form: {
        keyword: '',
        from_date: '',
        to_date: '',
        status: this.customStatusData || {
          options: [
            {
              value: 'All',
              label: this.$t('lbl_all')
            },
            {
              value: 1,
              label: this.$t('title.lbl_processing')
            },
            {
              value: 2,
              label: this.$t('title.lbl_has_result')
            }
          ],
          value: 'All'
        }
      },
      formData: null,
      typing: false,
      debounce: null
    }
  },
  mounted () {
    // this.form.from_date = this.moment().format('YYYY-MM-DD')
    // this.form.to_date = this.moment().format('YYYY-MM-DD')
  },
  computed: {
    maxDateValue () {
      return this.isMaxDateToday ? new Date().toISOString().split('T')[0] : ''
    }
  },
  watch: {
    customStatusData (data) {
      if (data) {
        this.form = {
          ...this.form,
          status: {
            ...this.form.status,
            value: data.value
          }
        }
      }
    }
  },
  methods: {
    handleFilters () {
      this.formData = {
        status: this.form.status.value === 'All' ? '' : this.form.status.value,
        keyword: this.form.keyword,
        from_date: this.form.from_date ? this.moment(this.form.from_date).valueOf() : '',
        to_date: this.isDateRange ? (this.form.to_date ? this.moment(this.form.to_date).valueOf() : '') : this.form.from_date ? this.moment(this.form.from_date).valueOf() : ''
      }

      this.$emit('setFilters', this.formData)
    },
    debounceSearch () {
      this.typing = true
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        this.typing = false
        this.formData = {
          ...this.formData,
          keyword: this.form.keyword
        }
        this.$emit('setFilters', this.formData)
      }, 600)
    }
  }
}
</script>
